import { useState } from "react";
import { useTranslation } from "react-i18next";
import useOutletServiceRepositories from "../repositories/outlet_service";
import { useNavigate,useSearchParams } from 'react-router-dom';
import Pagination from "../components/pagination";

export default function ServiceCenter(props){

    const { i18n, t } = useTranslation();
    const navigate = useNavigate()

    const [searchParams, setSearchParams] = useSearchParams()
    const page = searchParams.get('page')
    const [paginate,set_paginate] = useState(15);
    const [location, setLocation] = useState({ lat: 0, long: 0 });
    const [modalDetail,setModalDetail] = useState(true)

    const { data: listData,ori_data, isLoading: isLoadingListData, mutate: mutateListData } = useOutletServiceRepositories(location,page,paginate)

    const startGeoLocation=()=>{
        const onSuccess = (position) => {
          setLocation({
            lat: position.coords.latitude,
            long: position.coords.longitude
          });
        }
    
        const onError = (error) => {
          // console.log(error.message)
        }
        navigator.geolocation.getCurrentPosition(onSuccess, onError,{enableHighAccuracy:true});
        mutateListData()
    }
    return(
        <div className="dashboard-page">
            <a href="/service-center" class="flex font-bold text-lg items-center p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-200 group">
            <svg width="28" height="28" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M12 20.8995L16.9497 15.9497C19.6834 13.2161 19.6834 8.78392 16.9497 6.05025C14.2161 3.31658 9.78392 3.31658 7.05025 6.05025C4.31658 8.78392 4.31658 13.2161 7.05025 15.9497L12 20.8995ZM12 23.7279L5.63604 17.364C2.12132 13.8492 2.12132 8.15076 5.63604 4.63604C9.15076 1.12132 14.8492 1.12132 18.364 4.63604C21.8787 8.15076 21.8787 13.8492 18.364 17.364L12 23.7279ZM12 13C13.1046 13 14 12.1046 14 11C14 9.89543 13.1046 9 12 9C10.8954 9 10 9.89543 10 11C10 12.1046 10.8954 13 12 13ZM12 15C9.79086 15 8 13.2091 8 11C8 8.79086 9.79086 7 12 7C14.2091 7 16 8.79086 16 11C16 13.2091 14.2091 15 12 15Z"></path></svg>
                <span class="ms-3">{t('sidebar.service_center')}</span>
            </a>
            <div class="grid grid-cols-3 gap-4 mb-4 text-left pl-5">
                {
                    listData?.length > 0 && listData.map((row,index) => 
                    <div className="grid cursor-pointer" onClick={() => navigate("detail/"+row.id,{state:{row}})}>
                        <h5 className="font-bold">{row.name}</h5>
                        <p className="text-xs mt-1 line-clamp-3">
                            {row.address}
                        </p>
                        <p className="text-xs mt-2">{row.contact_number}</p>
                    </div>
                    )
                }
            </div>
            <div className="flex">
                <Pagination links={ori_data?.links} from={ori_data?.from} to={ori_data?.to} total={ori_data?.total} />
            </div>
        </div>
    )
}